import { render, staticRenderFns } from "./save-capture.vue?vue&type=template&id=52e6f598&"
import script from "./save-capture.vue?vue&type=script&lang=js&"
export * from "./save-capture.vue?vue&type=script&lang=js&"
import style0 from "./save-capture.vue?vue&type=style&index=0&id=52e6f598&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports